import { render, staticRenderFns } from "./vorstossSubmitDialog.vue?vue&type=template&id=0bc1df38"
import script from "./vorstossSubmitDialog.vue?vue&type=script&lang=js"
export * from "./vorstossSubmitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports